<template>
  <div id="app">
    <!-- 英语，越南语，印尼语，泰语，俄罗斯语，阿拉伯语，西班牙语 -->
    <keep-alive>
      <router-view :width="width"></router-view>
    </keep-alive>
  </div>
</template>
<script>
import Vue from 'vue'
export default {
  name: 'App',
  components: {},
  data() {
    //这里存放数据
    return {
      show: false,
      width: '',
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  computed: {
    i18n() {
      return this.$t("message");
    },
    nowLanguage() {
      return this.$store.state.nowLanguage;
    }
  },
  created() {
    this.$getRequest("/home/brand").then((res) => {
      if (res.code == 200) {
        let data = res.data;
        this.$store.state.navInfo = data.right;
        this.$store.state.qrcode = data.arr.bottom_qrcode;
        this.$store.state.typeList = [];
        this.$store.state.videoBrand = res.data.videoBrand;
        this.$store.state.newsBrand = res.data.newsBrand;
        this.$store.state.contactBrand = res.data.contactBrand;
        this.$store.state.freeBrand = res.data.arr.recycle_brand;
        data.ClassArr.forEach(item => {
          let str = {
            id: item.id,
            name: item.title,
            //空格替换为中划线
            link: `/product/${item.title.replaceAll(/\s+/g, "-")}`
          }
          this.$store.state.typeList.push(str)
        });
        this.updataMenu();
      }
    });
  },
  destroyed() {

  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  watch: {
    nowLanguage(newValue, oldValue) {
      this.$getRequest("/home/brand").then((res) => {
        if (res.code == 200) {
          let data = res.data;
          this.$store.state.navInfo = data.right;
          this.$store.state.qrcode = data.arr.bottom_qrcode;
          this.$store.state.typeList = [];
          data.ClassArr.forEach(item => {
            let str = {
              id: item.id,
              name: item.title,
              //空格替换为中划线
              link: `/product/${item.title.replaceAll(/\s+/g, "-")}`
            }
            this.$store.state.typeList.push(str)
          });
          // console.log(159, this.$store.state.typeList)

          this.updataMenu();
        }
      });
    }
  },
  methods: {
    // menu更新
    updataMenu() {
      let data = [{
        id: "1",
        name: this.i18n.nav.home,
        link: '/home',
        child: []
      },
      {
        id: "2",
        name: this.i18n.nav.about,
        link: '/about-us',
        child: []
      },
      {
        id: "3",
        name: this.i18n.nav.products,
        link: '/product',
        child: this.$store.state.typeList
      },
      {
        id: "4",
        name: this.i18n.nav.news,
        link: '/news',
        child: [{
          id: "41",
          name: this.i18n.about.new1,
          link: '/news?type=1',
          link: '/news',
        }, {
          id: "42",
          name: this.i18n.about.new2,
          link: '/news?type=2',
          link: '/news/company-news',
        }, {
          id: "43",
          name: this.i18n.about.new3,
          link: '/news?type=3',
          link: '/news/industry-news',
        }]
      },
      {
        id: "5",
        name: this.i18n.nav.video,
        link: '/video',
        child: []
      }, {
        id: "6",
        name: this.i18n.nav.free,
        link: '/recycle-free-tech',
        child: []
      },
      {
        id: "7",
        name: this.i18n.nav.contact,
        link: '/contact',
        child: []
      },
        // {
        //     id:"8",
        //     name:this.i18n.nav.vr,
        //     link:'/video/vr',
        //     child:[]
        // }
      ]
      this.$store.state.menuData = data;
      this.$forceUpdate();
    },
    handleScroll() {
      this.$store.state.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    }
  }
}
</script>
<style lang="less">
/* 隐藏滚动条轨道 */
::-webkit-scrollbar {
  width: 8px;
  position: fixed;
}

/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
  background-color: darkgrey;
  border-radius: 10px;
}

/* 滚动条轨道 */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* 鼠标移动到文字上样式 */
.textHover:hover {
  color: #2268EB !important;

  a {
    color: #2268EB !important;
  }
}

.clicka:hover {
  text-decoration: underline;
}

/* 鼠标移动到可选择上样式 */
.listHover:hover .picBox img {
  transform: scale(1.1);
  transition: transform 0.4s ease;
}

.listHover:hover .pic img {
  transform: scale(1.1);
  transition: transform 0.4s ease;
}

.listHover2:hover img {
  transform: scale(1.1);
  transition: transform 0.4s ease;
}

.listHover3:hover {
  cursor: pointer;
  transform: translateY(-10px);
  transition: transform 0.4s ease;
}

.proHover:hover {
  cursor: pointer;

  .pic {
    img {
      transform: scale(1.1);
      transition: transform 0.4s ease;
    }
  }

  .title {
    color: #3273FF !important;
  }
}

/* 标移动到按钮上样式 1 */
.btnHover:hover {
  cursor: pointer;
  transform: translateY(-3px);
  color: #FFFFFF !important;
  background: #2268EB !important;
  box-sizing: border-box;
  transition: transform 0.4s ease;
}

.btnHover2:hover {
  cursor: pointer;
  transform: translateY(-3px);
  transition: transform 0.4s ease;
}

.el-popover {
  padding: 0 !important;
  border: none !important;
  background: transparent !important;
}

.el-popper {
  .popper__arrow {
    display: none !important;
  }
}

.el-carousel {
  .el-carousel__container {
    .el-carousel__arrow {
      display: none !important;
      position: relative !important;
    }
  }
}

@media screen and (max-width: 768px) {
  /* 隐藏滚动条轨道 */

}
</style>
